import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController { // eslint-disable-line import/prefer-default-export
  static get COMPONENT() { return () => import('@/vue/pages/clients/purchases/index.vue') }
}
